/** @format */
import { ActivatedRoute, Router } from '@angular/router';
import { Component, EventEmitter, Input, Output, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconSignCircledCheckOutline
} from '@dsg-tech/homefield-angular-icons';

@Component({
	selector: 'pdp-custom-components-customizer-summary',
	templateUrl: './customizer-summary.component.html',
	styleUrl: './customizer-summary.component.scss',
	imports: [HomefieldIconLibraryModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CustomizerSummaryComponent {
	@Input() customizedAttributes: { name: string; value: string }[];
	@Input() isCustomizationSelected: boolean;
	@Output() openCustomPanel = new EventEmitter<boolean>();

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		homefieldIconsLibraryService: HomefieldIconsLibraryService
	) {
		homefieldIconsLibraryService.registerIcons([homefieldIconSignCircledCheckOutline]);
	}

	public openEditCustomPanel() {
		this.openCustomPanel.emit(true);
	}

	trackByFn(index: number, item: { name: string; value: string }): string {
		return index.toString() + item.name + item.value;
	}
}
